import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Box, Stack } from "@mui/material";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useState } from "react";
import { validateNewForm } from "./../../utils/graph-helper";

export default function RadioField({ heading, options, name }) {
  let requirements = useStoreState((state) => state.requirements);
  let setRequirements = useStoreActions((actions) => actions.setRequirements);
  if (undefined === requirements[name]) {
    setRequirements({ ...requirements, [name]: "Characterized Resin" });
  }

  let virginDialogErrors = useStoreState((state) => state.virginDialogErrors);
  let setVirginDialogErrors = useStoreActions(
    (actions) => actions.setVirginDialogErrors
  );

  let newFormErrors = useStoreState((state) => state.newFormErrors);
  const setNewFormErrors = useStoreActions(
    (actions) => actions.setNewFormErrors
  );

  let recycledDialogErrors = useStoreState(
    (state) => state.recycledDialogErrors
  );

  let setRecycledDialogErrors = useStoreActions(
    (actions) => actions.setRecycledDialogErrors
  );

  const handleChange = (event) => {
    // alert(event.target.value);
    // alert(name);
    /* set the state parameter here */
    if (name === "virginResin") {
      if (event.target.value === "New Resin") {
        let erroRes = validateNewForm(virginDialogErrors);
        if (erroRes) {
          setNewFormErrors(() => {
            // This `prevErrors` is the latest state from the store
            return {
              ...newFormErrors,
              virgin: {
                required: false,
                highlight: false,
              },
            };
          });
        } else {
          setNewFormErrors(() => {
            // This `prevErrors` is the latest state from the store
            return {
              ...newFormErrors,
              virgin: {
                required: true,
                highlight: false,
              },
            };
          });
        }
        //alert("new resin");
        /* Check here popup values are field or not */
      } else {
        if (
          requirements?.selectedVirginResin == "" ||
          requirements?.selectedVirginResin == null
        ) {
          setNewFormErrors(() => {
            // This `prevErrors` is the latest state from the store
            return {
              ...newFormErrors,
              virgin: {
                required: true,
                highlight: false,
              },
            };
          });
        } else {
          setNewFormErrors(() => {
            // This `prevErrors` is the latest state from the store
            return {
              ...newFormErrors,
              virgin: {
                required: false,
                highlight: false,
              },
            };
          });
        }
        /* check here if textbox have value or not if no value */
        /* unset popup values to false */
      }
    } else if (name === "recycledResin") {
      if (event.target.value === "New Resin") {
        /* unset charachterized resin value to false */
        let erroRes = validateNewForm(recycledDialogErrors);
        if (erroRes) {
          setNewFormErrors(() => {
            // This `prevErrors` is the latest state from the store
            return {
              ...newFormErrors,
              recycled: {
                required: false,
                highlight: false,
              },
            };
          });
        } else {
          setNewFormErrors(() => {
            // This `prevErrors` is the latest state from the store
            return {
              ...newFormErrors,
              recycled: {
                required: true,
                highlight: false,
              },
            };
          });
        }
      } else {
        /* unset popup values to false */
        if (
          requirements?.selectedRecycledResin == "" ||
          requirements?.selectedRecycledResin == null
        ) {
          setNewFormErrors(() => {
            // This `prevErrors` is the latest state from the store
            return {
              ...newFormErrors,
              recycled: {
                required: true,
                highlight: false,
              },
            };
          });
        } else {
          setNewFormErrors(() => {
            // This `prevErrors` is the latest state from the store
            return {
              ...newFormErrors,
              recycled: {
                required: false,
                highlight: false,
              },
            };
          });
        }
      }
    }
    setRequirements({ ...requirements, [name]: event.target.value });
  };

  return (
    <FormControl>
      <Stack spacing={1}>
        <FormLabel
          id="demo-controlled-radio-buttons-group"
          sx={{
            fontSize: "16px !important",
            fontWeight: "600 !important",
            lineHeight: "24px",
            color: "#303C43 !important",
          }}
        >
          {heading}
        </FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={(requirements && requirements[name]) || ""}
          onChange={handleChange}
          sx={{}}
        >
          {options.map((option, index) => {
            return (
              <FormControlLabel
                value={option}
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "#385DAE",
                      },
                      marginLeft: index == 0 ? 0 : 5,
                    }}
                  />
                }
                label={
                  <span style={{ fontFamily: "Source Sans Pro" }}>
                    {option}
                  </span>
                }
                className='font-16 font-weight-600 line-height-24"'
                sx={{
                  fontSize: "16px",
                  fontWeight: "400 !important",
                  lineHeight: "24px",
                  color: "#303C43",
                }}
              />
            );
          })}
        </RadioGroup>
      </Stack>
    </FormControl>
  );
}
